import { getApv, postApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  closeBottomSheet,
  getAccountModalLayer,
  getBankModalLayer,
  getIframe,
  setAddEventListener,
  setBottomSheet,
  setNumericOnly,
  stringToHTML,
} from '../../helpers';
import { deserialize, serialize } from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';
import { amtFormatter, isEmpty, removeComma } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const ChargRemitc = {
  render: async () => {
    return `<div>
                <a class="c_back" id="connect_pay_back_button"></a>
            </div>
            <div class="c_title1">충전머니 송금</div>
            <div class="form-group m_b_20">
                <label class="c_label1">충전머니 잔액(송금 가능금액)</label>
                <input type="text" id="chrg_bal" class="form-control c_input1 skin1_input" disabled />
            </div>
            <div class="form-group m_b_20">
                <div class="c_box">
                    <label class="c_label1">입금계좌</label>
                    <span class="skin1_span m_b_5 c_span1" id="account_select">내 계좌로 송금 ></span>
                </div>
                <div class="c_bod1 c_box skin1_bod" id="bank_select">
                    <input type="hidden" id="bank_cd" name="bank_cd" />
                    <div class="c_label4_3" id="bank_nm">은행</div>
                    <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
                </div>
                <div class="m_t_10">
                    <input type="text" class="form-control c_input1 skin1_input" id="accno" placeholder="계좌번호" pattern="[0-9]*" inputmode="numeric">
                    <input type="hidden" id="acc_entyno" name="acc_entyno" />
                </div>
            </div>
            <div class="form-group m_b_20">
                <label class="c_label1">보낼금액</label>
                <input type="text" class="form-control c_input1 skin1_input" id="out_amt" placeholder="보낼금액" pattern="[0-9]*" inputmode="numeric">
            </div>
            <div class="bottom_btn_wrapper">
                <button class="btn c_btn1 skin1_btn" data-toggle="modal" data-target="#charg_confirm" id="remitc_commit">확인</button>
            </div>`;
  },
  afterRender: async () => {
    setAlertModal();
    setAlertModal(true, 'confirm_alert_modal');

    setNumericOnly('accno');
    setNumericOnly('out_amt');

    try {
      // 충전머니 잔액조회
      const meneyBalanceResult = await getApv('charging/moneyBalance');
      getIframe().getElementById('chrg_bal').value = amtFormatter(
        meneyBalanceResult.chrgBal || 0
      );

      const accountModalLayer = await getAccountModalLayer();
      stringToHTML(accountModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );

      const bankModalLayer = await getBankModalLayer();
      stringToHTML(bankModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
    } catch (e) {
      showAlertModal('오류', e.resultMessage || e, () => history.back());
      console.error(e);
    }

    // 출금계좌 변경
    const handleAccountChanged = (accountInfoStr) => {
      if (isEmpty(accountInfoStr)) return;
      const accountInfo = deserialize(accountInfoStr);

      getIframe().getElementById('acc_entyno').value = accountInfo.accEntyno;
      getIframe().getElementById('bank_cd').value = accountInfo.bnkCode;
      getIframe().getElementById('bank_nm').innerHTML = accountInfo.bnkName;
      getIframe().getElementById('accno').value = accountInfo.accno;

      closeBottomSheet('account_select');
    };

    // 은행 변경
    const handleBankChanged = (bankInfoStr) => {
      if (isEmpty(bankInfoStr)) return;

      const bankInfo = deserialize(bankInfoStr);

      getIframe().getElementById('bank_cd').value = bankInfo.bankCd;
      getIframe().getElementById('bank_nm').innerHTML = bankInfo.bankNm;

      closeBottomSheet('bank_select');
    };

    const onClickCommit = async () => {
      if (isEmpty(getIframe().getElementById('bank_cd').value.trim())) {
        showAlertModal('알림', '입금할 은행을 선택해주세요.');
        return;
      }
      if (isEmpty(getIframe().getElementById('accno').value.trim())) {
        showAlertModal('알림', '입금할 계좌번호를 입력해주세요.');
        return;
      }
      if (isEmpty(getIframe().getElementById('out_amt').value.trim())) {
        showAlertModal('알림', '보낼금액을 입력해주세요.');
        return;
      }
      if (
        Number(
          removeComma(getIframe().getElementById('chrg_bal').value)
            .replace('원', '')
            .trim()
        ) < Number(getIframe().getElementById('out_amt').value.trim())
      ) {
        showAlertModal('알림', '충전머니 잔액이 부족합니다.');
        return;
      }

      const accEntyno = getIframe().getElementById('acc_entyno').value;
      const bankCd = getIframe().getElementById('bank_cd').value;
      const bankNm = getIframe().getElementById('bank_nm').innerHTML;
      const accno = getIframe().getElementById('accno').value;
      const outAmt = getIframe().getElementById('out_amt').value;

      const execTransfer = async (tranData) => {
        const res = await postApv('charging/rsvd/transfer', tranData);

        // 완료페이지에서 사용할 데이터
        // sessionStorage.setItem('CONPAY_COMPLETE_INFO', serialize(tranData));

        sessionStorage.setItem(
          'CONPAY_COMPLETE_INFO',
          serialize({
            ...tranData,
            ...res,
          })
        );

        // pin 확인 -> 완료페이지
        pushRouter(
          {
            mode: 'PIN_CHECK',
            nextHash: routes.remitcComplete.hashPath,
            nextState: {
              refererHash: routes.chargRemitc.hashPath,
              // rsvdUrl: 'charging/rsvd/transfer',
              // aprvUrl: history.state.aprvUrl,
              // bankNm,
              // accEntyno,
              // accno,
              // outAmt,
            },
          },
          null,
          routes.enterPwd.hashPath,
          () => {
            setDisableBackControl();
          }
        );
      };

      try {
        // 예금주검증
        const acctNameData = {
          bankCd,
          accEntyno,
          searchAcctNo: accno,
        };
        const nameRes = await postApv('common/getAcctName', acctNameData);
        const accOwnerName = nameRes.accOwnerName;

        const msg = `입금계좌: ${bankNm} ${accno}
        예금주: ${accOwnerName}
        보낼금액: ${amtFormatter(outAmt)}원
        `;

        const tranData = {
          trDiv: '3202',
          outAmt,
          accEntyno,
          tgtBnkCode: bankCd,
          tgtAccno: accno,
          tgtName: accOwnerName,
        };
        showAlertModal(
          '알림',
          msg,
          () => execTransfer(tranData),
          'confirm_alert_modal'
        );
      } catch (e) {
        showAlertModal('오류', e.resultMessage);
        console.error(e.resultMessage);
      }
    };

    // setEvent
    setAddEventListener('connect_pay_back_button', () => history.back());

    getIframe()
      .querySelectorAll('#deposit_account_list > div')
      .forEach((element) =>
        element.addEventListener('click', () => {
          if (element.getAttribute('id') == 'account_regi') {
            pushRouter(null, null, routes.accountRegi.hashPath);
            return;
          }
          handleAccountChanged(element.getAttribute('value'));
        })
      );

    getIframe()
      .querySelectorAll('#bank_list > div > img')
      .forEach((element) =>
        element.addEventListener('click', () => {
          handleBankChanged(element.getAttribute('value'));
        })
      );

    setAddEventListener('remitc_commit', onClickCommit);

    setBottomSheet('account_select');
    setBottomSheet('bank_select');
  },
};
export default ChargRemitc;
